<template>
  <div class="onfocus__queries-container q-text-dark">
    <div v-if="isMobileView" class="onfocus__queries-content q-row">
      <AccordionQueries :queries-header="queriesHeader" :queries="queries" :can-remove="canRemove"/>
    </div>
    <div v-else class="onfocus__queries-content q-row">
      <QueriesHeader :header="queriesHeader"/>
      <QueriesList :queries="queries" :can-remove="canRemove"/>
      <ClearQueriesButton v-if="canRemove"/>
    </div>
  </div>


</template>

<script lang="ts" setup>

import QueriesHeader from "./QueriesHeader.vue";
import QueriesList from './QueriesList.vue'
import AccordionQueries from './AccordionQueries.vue'
import ClearQueriesButton from './ClearQueriesButton.vue'
import {defineProps} from "vue";
import {useMobileViewStore} from "@/store/MobileViewStore";
import {storeToRefs} from "pinia";

const mobileViewStore = useMobileViewStore();


defineProps(['queriesHeader', 'queries', 'canRemove'])

const {isMobileView} = storeToRefs(mobileViewStore)

// window.addEventListener('resize', mobileViewStore.updateIsMobileView);

</script>

<style scoped>


a {
  cursor: pointer;
}
</style>